export default "__VITE_ASSET__B5XrQ6JE__"